<!-- ChartModal.vue -->
<template>


  <div class="step" id="step-5">
    <div class="col-12 col-lg-6 offset-lg-3 lg:py-0  ">

      <div class="grid content-start">
        <div class="hora-form-step">
          <div class="hora-form-confirm mb-6">
            <i class="hora-text-primary inline fa-light text-xl fa-badge-check ml-2"></i>
            <h5 class="hora-text-primary inline text-xl">تایید اطلاعات</h5>

          </div>
          <hr>
          <div class="hora-form-information mt-10">
            <p class="mb-2 text-slate-600 leading-10">نام:  {{ chartRequest.title }}</p>
            <p class="mb-2 text-slate-600 leading-10">جنسیت:  {{ genderText }}</p>
            <p class="mb-2 text-slate-600 leading-10">تاریخ تولد:  {{ chartRequest.year }}/{{ chartRequest.month }}/{{ chartRequest.day }}</p>
            <p class="mb-2 text-slate-600 leading-10">ساعت تولد:  {{ chartRequest.hour }}:{{ chartRequest.min }}</p>
            <p class="mb-2 text-slate-600 leading-10">شهر محل تولد:  {{ chartRequest.display_loc }}</p>
            <p v-if="chartRequest.alert_text" class="mb-2 text-slate-600 leading-10">{{ chartRequest.alert_text }}</p>
          </div>
        </div>


        <div class="hora-form-buttons grid grid-cols-2 gap-4">
          <a @click="$emit('previousStep')" class="flex justify-center relative items-center rounded-lg py-2 px-3 text-slate-400 bg-slate-200 border border-slate-300" disabled>
            <svg class="absolute right-3" width="14" height="16" viewBox="0 0 14 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M13.8531 8.35313C14.0469 8.15938 14.0469 7.84063 13.8531 7.64688L8.3531 2.14688C8.15935 1.95313 7.8406 1.95313 7.64685 2.14688C7.4531 2.34063 7.4531 2.65938 7.64685 2.85313L12.2937 7.50001L0.499976 7.50001C0.224976 7.5 -2.42471e-05 7.725 -2.42711e-05 8C-2.42952e-05 8.27501 0.224976 8.5 0.499976 8.50001L12.2937 8.50001L7.64685 13.1469C7.4531 13.3406 7.4531 13.6594 7.64685 13.8531C7.8406 14.0469 8.15935 14.0469 8.3531 13.8531L13.8531 8.35313Z" fill="#002E5B"/>
            </svg>

            <span>  قبلی</span>
          </a>
          <a @click="$emit('submit-chart')" id="nextStep01" class="flex justify-center relative items-center rounded-lg py-2 px-3 hora-bg-primary text-white">
            <span>محاسبه</span>
            <svg class="absolute left-3" width="14" height="16" viewBox="0 0 14 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <g clip-path="url(#clip0_8_155)">
                <path d="M0.146777 7.64687C-0.0469727 7.84062 -0.0469727 8.15937 0.146777 8.35312L5.64678 13.8531C5.84053 14.0469 6.15928 14.0469 6.35303 13.8531C6.54678 13.6594 6.54678 13.3406 6.35303 13.1469L1.70615 8.49999H13.4999C13.7749 8.49999 13.9999 8.27499 13.9999 7.99999C13.9999 7.72499 13.7749 7.49999 13.4999 7.49999H1.70615L6.35303 2.85312C6.54678 2.65937 6.54678 2.34062 6.35303 2.14687C6.15928 1.95312 5.84053 1.95312 5.64678 2.14687L0.146777 7.64687Z" fill="white"/>
              </g>
              <defs>
                <clipPath id="clip0_8_155">
                  <rect width="14" height="16" fill="white"/>
                </clipPath>
              </defs>
            </svg>

          </a>
        </div>




      </div>
    </div>
  </div>







</template>

<script>

import '../chartFormFress.css'


export default {
  name: 'ChartModal',
  props: {
    chartRequest: {
      type: Object,
      required: true,
    }
  },
  computed: {
    genderText() {
      switch (this.chartRequest.gender) {
        case "0":
          return 'زن';
        case "1":
          return 'مرد';
        case "2":
          return 'they';
        default:
          return '';
      }
    }
  }
};
</script>

<style scoped>
/* Add any modal-specific styles here */
</style>
